<template>
    <div
        ref="bar"
        class="background">
        <MediaButton/>
        <ReplayButton/>
        <ProgressBar/>
        <div
            v-if="progress < 90"
            class="progress-text">
            下载进度：{{ progress }}%
        </div>
        <div v-else
            class="progress-text">
            下载完成
        </div>
        <RateButton/>
        <TimeArea/>
    </div>
</template>

<script>
 import MediaButton from "./MediaButton.vue"
 import ReplayButton from "./ReplayButton.vue"
 import ProgressBar from "./ProgressBar.vue"
 import RateButton from "./RateButton.vue"
 import TimeArea from "./TimeArea.vue"
 import { mouseSeekVideo } from "../event/input.js"
 import EventBus from "../event/event-bus.js"

 export default {
     name: 'ControllerBar',
     props: {
     },
     data() {
         return {
             progress: 0
         }
     },
     components: {
         MediaButton,
         ReplayButton,
         ProgressBar,
         TimeArea,
         RateButton,
     },
     created() {
     },
     mounted() {
         EventBus.$on("downloadProgress", this.updateProgress)

         this.$refs.bar.addEventListener("mousewheel", mouseSeekVideo)
     },
     beforeDestroy() {
         EventBus.$off("downloadProgress")
     },
     methods: {
         updateProgress(progress) {
             this.progress = progress
         }
     }
 }
</script>

<style scoped>
 .background {
     background-color: #20273E;
     height: 44px;
     width: 100%;

     display: flex;
     flex-direction: row;
     align-items: center;

     padding-left: 10px;
     padding-right: 10px;
 }

 .progress-text {
     width: 110px;
     color: #AAA;
     margin-left: 10px;
     margin-right: 10px;
     text-align: center;
 }
</style>
